import { Box } from '@chakra-ui/layout';
import { useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

interface CardProps {}

const Card: React.FC<CardProps> = ({ children }) => {
  const styles = useMultiStyleConfig('Card', { variant: 'doubleBorder' });
  return (
    <Box __css={styles.container}>
      <Box __css={styles.card}>{children}</Box>
    </Box>
  );
};

export default Card;
